<template>
	<div>
		<Card>
			<Row :gutter="16">
				<Col span="24">
				<div class="global-tool-bar">
					<div class="left-bar">
						<span class="title">佣金设置</span>
					</div>
				</div>
				</Col>
			</Row>

			<Row :gutter="16" style="margin:10px;">
				<Form label-position="top">
					<Col span="4">
					<FormItem label="佣金比例(百分比,如10为10%)">
						<InputNumber v-model="seedFarm.commissionRate" :min="0" :max="100" :active-change="false"
							style="width:100%"></InputNumber>
					</FormItem>
					</Col>
				</Form>
			</Row>
			<Row :gutter="16" style="margin:10px;">
				<Form label-position="top">
					<Col span="4">
					<FormItem>
						<Button type="success" @click="saveSeedFarm()">保存</Button>
					</FormItem>
					</Col>
				</Form>
			</Row>
		</Card>
	</div>
</template>

<script>
import { getSeedFarmModel, saveSeedFarmCommissionRate } from '@/api/modules/finance-management/commission';
export default {
    name: 'seedFarmCommission',
    components: {},
    data() {
        return {
            seedFarm: {
                seedFarmUuid:'',
                commissionRate:0
            }
				
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
				    this.getSeedFarm();
        },
        saveSeedFarm(){
            saveSeedFarmCommissionRate({ seedFarmUuid:this.seedFarm.seedFarmUuid, commissionRate:this.seedFarm.commissionRate }).then(res => {
					    if (res.code === 0) {
					        this.$Message.success('苗场佣金设置成功！');
					    }
            });
        },
        getSeedFarm(){
            getSeedFarmModel({}).then(res => {
					    if (res.code === 0) {
					        this.seedFarm = res.data.seedFarm;
					    }
            });
        }
    }
};
</script>

<style>
</style>
